import React from 'react';
import { Link } from 'react-router-dom';

import styles from './ApplyHero.module.scss';

export default function ApplyHero() {
  return (
    <div className={styles.mainB}>
      <div>
        <h3>Request a Fi Nano sample today!</h3>
      </div>

      <div>
        <Link to="/apply" className="btn-black-flat">
          Request a sample
        </Link>
      </div>
    </div>
  );
}
